<template>
    <li @click="handleToggleDropdown">
        Produits
        <ul class="dropdown--content"  :class="{active: isActive}">
            <slot></slot>
        </ul>
    </li>
</template>

<script>
    export default {
        name: "Dropdown",
        data() {
            return {
                isActive: false
            }
        },
        methods: {
            handleToggleDropdown() {
                this.isActive = !this.isActive
            }
        }
    }
</script>

<style lang="scss" scoped>

    .dropdown--content {
        display: none;
        z-index: 10;
        flex-direction: column;
        position: absolute;
        margin-top: -33px;
        background-color: #ffffff;
        min-width: 300px;
        line-height: 25px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        padding: 5px 0;

        li {
            margin-bottom: 10px;
            width: 100%;
            padding: 5px;

            a {
                padding: 0;
                border: 0;

                & span {
                    font-style: italic;
                }
            }

            &:hover {
                transition: all 0.3s;
                background: $dark;
                a {
                    color: #ffffff;
                }
            }
        }
        &.active {
            display: flex;
        }
    }
</style>